import React, { CSSProperties, useEffect, useRef } from "react";
import "./Checkbox.less";

export interface CheckboxProps {
   disabled?: boolean;
   checked?: boolean;
   defaultChecked?: boolean;
   onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
   indeterminate?: boolean;
   onClick?: React.MouseEventHandler<HTMLButtonElement>;
   className?: string;
   children?: React.ReactNode;
   name?: string;
   key?: React.Key;
   id?: string;
   customStyle?: CSSProperties;
}

export const CheckboxCore: React.FC<CheckboxProps> = ({
   disabled = false,
   checked,
   defaultChecked,
   onChange,
   indeterminate = false,
   onClick,
   className = "",
   children,
   name,
   id,
   key,
   customStyle,
}) => {
   const checkboxRef = useRef<HTMLInputElement>(null);

   useEffect(() => {
      if (checkboxRef.current) {
         checkboxRef.current.indeterminate = indeterminate;
      }
   }, [checkboxRef, indeterminate]);

   const checkbox = (
      <span className={`${className} bp2-checkbox`} onClick={onClick}>
         <input
            type="checkbox"
            id={id}
            style={customStyle}
            className="bp2-checkbox__input"
            data-testid="bp2-checkbox__input"
            ref={checkboxRef}
            checked={checked}
            disabled={disabled}
            defaultChecked={defaultChecked}
            onChange={(e) => {
               onChange && onChange(e);
            }}
            name={name ? name : "checkbox-name"}
            key={key}
         />
         <div style={customStyle} className="bp2-checkbox__box"></div>
      </span>
   );

   return children ? (
      <label className="bp2-checkbox-wrapper">
         {checkbox}
         <span>{children}</span>
      </label>
   ) : (
      checkbox
   );
};
